import React, { useState } from 'react';
import { AnimatePresence } from 'framer-motion';
import Welcome from './components/Welcome';
import QuestionCard from './components/QuestionCard';
import EmailCapture from './components/EmailCapture';
import Results from './components/Results';
import AnimatedBackground from './components/AnimatedBackground';
import { questions } from './data/questions';
import { comprehensiveQuestions } from './data/comprehensiveQuestions';
import { calculateScores } from './utils/scoring';
import { saveResultToSheets } from './services/resultService';

function App() {
  const [currentStep, setCurrentStep] = useState('welcome');
  const [targetType, setTargetType] = useState(null);
  const [quizType, setQuizType] = useState(null);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [answers, setAnswers] = useState({});
  const [userInfo, setUserInfo] = useState({});
  const [scores, setScores] = useState({});

  const handleStart = (target, quiz) => {
    setTargetType(target);
    setQuizType(quiz);
    setCurrentStep('quiz');
  };

  const getCurrentQuestions = () => {
    return quizType === 'comprehensive' ? comprehensiveQuestions : questions;
  };

  const handleAnswer = (value) => {
    const currentQuestions = getCurrentQuestions();
    const newAnswers = { ...answers, [currentQuestions[currentQuestionIndex].id]: value };
    setAnswers(newAnswers);

    if (currentQuestionIndex < currentQuestions.length - 1) {
      setCurrentQuestionIndex(currentQuestionIndex + 1);
    } else {
      setCurrentStep('email');
    }
  };

  const handleEmailSubmit = async (formData) => {
    setUserInfo(formData);
    const calculatedScores = calculateScores(answers, quizType);
    setScores(calculatedScores);

    // Save to Google Sheets (connected via .env)
    const payload = {
      userInfo: formData,
      answers,
      scores: calculatedScores,
      quizType,
      targetType
    };

    saveResultToSheets(payload).then(success => {
      if (success) console.log('Neural data secured in Google Sheets');
    });

    setCurrentStep('results');
  };

  const handleRestart = () => {
    setCurrentStep('welcome');
    setTargetType(null);
    setQuizType(null);
    setCurrentQuestionIndex(0);
    setAnswers({});
    setUserInfo({});
    setScores({});
  };

  const currentQuestions = getCurrentQuestions();

  return (
    <div className="min-h-screen bg-brand-floral relative overflow-hidden text-brand-coffee font-manrope selection:bg-brand-crimson selection:text-white">
      <AnimatedBackground />
      
      <div className="relative z-10 w-full">
        <AnimatePresence mode="wait">
          {currentStep === 'welcome' && (
            <Welcome key="welcome" onStart={handleStart} />
          )}
          
          {currentStep === 'quiz' && (
            <QuestionCard
              key={`question-${currentQuestionIndex}`}
              question={currentQuestions[currentQuestionIndex]}
              currentIndex={currentQuestionIndex}
              totalQuestions={currentQuestions.length}
              onAnswer={handleAnswer}
              targetType={targetType}
            />
          )}

          {currentStep === 'email' && (
            <EmailCapture 
              key="email" 
              onSubmit={handleEmailSubmit} 
              targetType={targetType} 
            />
          )}

          {currentStep === 'results' && (
            <Results
              key="results"
              scores={scores}
              userInfo={userInfo}
              targetType={targetType}
              onRestart={handleRestart}
              quizType={quizType}
            />
          )}
        </AnimatePresence>
      </div>
    </div>
  );
}

export default App;